import { create } from 'zustand';
import { accountApi, getAuthToken, setAuthToken } from '../services/api';
import type { AccountUser } from '../services/api';

interface AuthState {
  token: string | null;
  user: AccountUser | null;
  isLoading: boolean;
  error: string | null;

  login: (email: string, password: string) => Promise<void>;
  register: (email: string, password: string) => Promise<void>;
  loginWithTelegram: (token: string) => Promise<void>;
  logout: () => void;
  refreshUser: () => Promise<void>;
  setUser: (user: AccountUser) => void;
}

export const useAuthStore = create<AuthState>()((set, get) => ({
  token: getAuthToken(),
  user: null,
  isLoading: false,
  error: null,

  login: async (email, password) => {
    set({ isLoading: true, error: null });
    try {
      const { data } = await accountApi.login(email, password);
      setAuthToken(data.access_token);
      set({ token: data.access_token, user: data.user, isLoading: false });
    } catch (e: any) {
      set({ isLoading: false, error: e?.response?.data?.detail || 'Login failed' });
      throw e;
    }
  },

  register: async (email, password) => {
    set({ isLoading: true, error: null });
    try {
      const { data } = await accountApi.register(email, password);
      setAuthToken(data.access_token);
      set({ token: data.access_token, user: data.user, isLoading: false });
    } catch (e: any) {
      set({ isLoading: false, error: e?.response?.data?.detail || 'Registration failed' });
      throw e;
    }
  },

  loginWithTelegram: async (token) => {
    set({ isLoading: true, error: null });
    try {
      const { data } = await accountApi.telegramLogin(token);
      setAuthToken(data.access_token);
      set({ token: data.access_token, user: data.user, isLoading: false });
    } catch (e: any) {
      set({ isLoading: false, error: e?.response?.data?.detail || 'Ссылка устарела. Откройте новую в боте.' });
      throw e;
    }
  },

  logout: () => {
    setAuthToken(null);
    set({ token: null, user: null });
  },

  refreshUser: async () => {
    if (!get().token) return;
    try {
      const { data } = await accountApi.me();
      set({ user: data });
    } catch {
      setAuthToken(null);
      set({ token: null, user: null });
    }
  },

  setUser: (user) => set({ user }),
}));
